<template>
  <div class="def-sku-sizes">
    <a
      v-for="(item, i) in result"
      :key="item.value"
      :href="item.detailPage"
      class="def-sku-item"
      :class="{
        'def-sku-item_active': item.active,
        'def-sku-item_disabled': item.disable || item.onOrder,
      }"
      rel="canonical"
      @click.prevent="changeSize(item.detailPage)"
    >
      {{ item.displayValue }}
    </a>
  </div>
</template>

<script lang="ts" setup>
import { IProductSize } from '@/storePinia/interfaces/IProduct/IProduct';
import { useSKU } from '@use/useSKU/useSKU';

const props = defineProps<{
  result: IProductSize[];
}>();
const emit = defineEmits(['changeSize']);

const sku = useSKU();

const changeSize = async (url: string) => {
  const response = await sku.getProductPageDataUsingUrl(url);

  emit('changeSize', response.product);
};
</script>

<style lang="scss" scoped>
.def-sku-sizes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.def-sku-item {
  display: flex;
  align-items: center;
  border: 1px solid #cacece;
  border-radius: 100px;
  height: 32px;
  padding: 0 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  text-transform: uppercase;
  &_active {
    background-color: var(--background-black);
    color: #fff;
    pointer-events: none;
  }

  &_disabled {
    color: var(--color-dark-grey);
    border-color: var(--color-dark-grey);
    position: relative;
    overflow: hidden;
    //pointer-events: none;
    &:after {
      content: '';
      height: 100px;
      width: 1px;
      background-color: currentColor;
      position: absolute;
      transform: rotate(65deg);
      left: 50%;
    }
  }
  &.def-sku-item_active.def-sku-item_disabled {
    border-color: #5f5f67;
    color: #b0b0b0;
    background-color: #ededed;
    &:after {
      background-color: #5f5f67;
    }
  }
}
</style>
